<template>
  <div class="d-flex flex-column align-items-center px-3">
    <p class="email-line">How To Cite the Data</p>
    <p>If you use FleetREDI data in a publication, please <a href="mailto:FleetREDI@nlr.gov">contact us</a> and include a citation in your publication consistent with the following format:</p>
    <blockquote>"FleetREDI." ([YEAR]). NLR. Accessed [DATE]: <a href="https://fleetredi.nlr.gov/"><em> https://fleetredi.nlr.gov/</em></a>.</blockquote>
  </div>
</template>
